var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.boleto.funding_instrument
    ? _c(
        "section",
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "payment-title mt-10" }, [
            _vm._v("seu boleto está pronto!")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "boleto-info" }, [
            _vm._v(
              "\n    Agora você pode realizar o pagamento com linha digitável ou imprimi-lo.\n    "
            ),
            _c("b", { staticClass: "mt-5", attrs: { id: "line_code" } }, [
              _vm._v(_vm._s(_vm.boleto.funding_instrument.line_code))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-small pl-5 pr-5 ml-10 btn-copy mt-10",
                class: {
                  "bg-purple-outline": !_vm.copied,
                  "bg-green": _vm.copied
                },
                on: { click: _vm.copyToClipBoard }
              },
              [
                _vm.copied
                  ? _c("img", {
                      staticClass: "mr-5",
                      attrs: { src: "/static/icon-check.svg", height: "10px" }
                    })
                  : _c("img", {
                      staticClass: "mr-5",
                      attrs: { src: "/static/icon-copy.svg", height: "10px" }
                    }),
                _vm._v(" "),
                _vm.copied
                  ? _c("span", [_vm._v("copiado!")])
                  : _c("span", [_vm._v("copiar")])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: _vm.boleto.funding_instrument.url_print,
                target: "_blank",
                rel: "noopener noreferrer"
              }
            },
            [_vm._m(1)]
          ),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n    Você contratou uma limpeza com menos de 72 horas de antecedência e selecionou boleto como forma de pagamento. Para confirmar a sua limpeza,\n    "
            ),
            _c(
              "b",
              { staticClass: "pointer", on: { click: _vm.openSupport } },
              [_vm._v("clique aqui")]
            ),
            _vm._v(
              " e envie o comprovante de pagamento com até 48 horas úteis antes da limpeza.\n  "
            )
          ]),
          _vm._v(" "),
          _c("faq")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "accept",
        attrs: {
          href: "https://www.donamaid.com/termos-de-uso",
          target: "_blank"
        }
      },
      [
        _vm._v(
          "\n    Ao finalizar a compra, você concorda com os nossos termos de uso\n    "
        ),
        _c("span", [
          _c("img", {
            staticClass: "rel-icon",
            attrs: { src: "/static/url.svg" }
          })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "boleto-download mt-20 mb-10" }, [
      _vm._v("\n      Baixar boleto\n      "),
      _c("span", [
        _c("img", {
          staticClass: "rel-icon",
          attrs: { src: "/static/download.svg" }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e7158330", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7158330","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Checkout/Payment/Boleto.vue
// module id = null
// module chunks = 